module.exports = __webpack_public_path__ + "static/media/exmpMCF-7Paclitaxel.be5e6d77.png";